// extracted by mini-css-extract-plugin
module.exports = {"projectPaneContainer":"ProjectPane_projectPaneContainer__H6PsC","projectWrapper":"ProjectPane_projectWrapper__OYdq0","projectContainer":"ProjectPane_projectContainer___z8AM"};